import { useState, useEffect } from 'react';
import { Card, LoadingSpinner } from '../components/Layout';
import api from '../services/api';

export function DocumentsPage() {
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState<any[]>([]);
  const [favorites, setFavorites] = useState<any[]>([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [docs, favs] = await Promise.all([
        api.getMyDocuments(),
        api.getFavoriteDocuments(),
      ]);
      setDocuments(docs || []);
      setFavorites(favs || []);
    } catch (error) {
      console.error('Error loading documents:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center p-8"><LoadingSpinner /></div>;
  }

  return (
    <div className="space-y-6">
      <Card>
        <h1 className="text-2xl font-bold text-white">Documents & SOPs</h1>
      </Card>

      {favorites.length > 0 && (
        <Card>
          <h2 className="text-xl font-bold text-white mb-4">⭐ Favorites</h2>
          <div className="space-y-2">
            {favorites.map((doc) => (
              <div key={doc.id} className="bg-gray-700 p-3 rounded-lg">
                <div className="text-white font-medium">{doc.title}</div>
                {doc.category && <div className="text-gray-400 text-sm">{doc.category}</div>}
              </div>
            ))}
          </div>
        </Card>
      )}

      <Card>
        <h2 className="text-xl font-bold text-white mb-4">All Documents</h2>
        {documents.length === 0 ? (
          <p className="text-gray-400 text-center py-4">No documents available</p>
        ) : (
          <div className="space-y-2">
            {documents.map((doc) => (
              <div key={doc.id} className="bg-gray-700 p-3 rounded-lg hover:bg-gray-600 cursor-pointer">
                <div className="text-white font-medium">{doc.title}</div>
                {doc.category && <div className="text-gray-400 text-sm">{doc.category}</div>}
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
